import React, { useState, useRef } from 'react';
import { Box } from '@mui/material';
import useQuizStyles from '../../styles/perfectMatch/quiz';

import goatImage from '../../assets/images/perfect_match/tap.png';
import womanImage from '../../assets/images/perfect_match/tipa.png';
import manImage from '../../assets/images/perfect_match/tip.png';
import logoText from '../../assets/images/perfect_match/logo.jpg';
import breweryImage from '../../assets/images/perfect_match/background.jpg';
import promoalcool from '../../assets/images/promo-despre-alcool.png';

interface QuizProps {
    onQuizComplete: (answers: string[]) => void;
}

interface Question {
    id: number;
    text: string;
    answers: {
        id: string;
        text: string;
    }[];
}

const questions: Question[] = [
    {
        id: 1,
        text: 'DACĂ RELAȚIA TA AR FI O BERE, EA AR FI:',
        answers: [
            { id: 'A', text: 'Savuroasă, necomplicată și lejeră' },
            { id: 'B', text: 'Intensă, memorabilă' },
            { id: 'C', text: 'Mereu surprinzătoare și jucăușă' }
        ]
    },
    {
        id: 2,
        text: 'CÂND SUNTEȚI ÎMPREUNĂ, CE FEL DE SEARĂ SE ANUNȚĂ?',
        answers: [
            { id: 'A', text: 'Relax total – povești lungi și bere rece' },
            { id: 'B', text: 'Râsete, glume interne și planuri spontane' },
            { id: 'C', text: 'Energie maximă – muzică, meci sau boardgames' }
        ]
    },
    {
        id: 3,
        text: 'CUM ÎȚI EXPRIMI AFECȚIUNEA?',
        answers: [
            { id: 'A', text: 'Cuvinte de afirmare: ex. „Ți-am păstrat ultima bere"' },
            { id: 'B', text: 'Cadouri – un Six Pack veritabil' },
            { id: 'C', text: 'Timp și bere de calitate' }
        ]
    },
    {
        id: 4,
        text: 'CEA MAI RĂCORITOARE DECLARAȚIE DE DRAGOSTE SUNĂ CAM AȘA:',
        answers: [
            { id: 'A', text: '"Ești persoana mea"' },
            { id: 'B', text: '"Nu m-am atins de berea ta"' },
            { id: 'C', text: '„Fac eu cinste și azi!"' }
        ]
    },
    {
        id: 5,
        text: 'CE FACE CA O RELAȚIE SĂ FUNCȚIONEZE „PE GUSTUL VOSTRU"?',
        answers: [
            { id: 'A', text: 'Echilibru – fiecare cu vibe-ul lui, dar bine potriviți' },
            { id: 'B', text: 'Momente simple, dar memorabile' },
            { id: 'C', text: 'Surprize mici care țin lucrurile interesante' }
        ]
    }
];

const Quiz: React.FC<QuizProps> = ({ onQuizComplete }) => {
    const classes = useQuizStyles();
    const [currentQuestion, setCurrentQuestion] = useState(0);
    const [answers, setAnswers] = useState<string[]>([]);

    const handleAnswerClick = (answerId: string, event: React.MouseEvent<HTMLButtonElement>) => {
        // Force blur to remove focus state
        event.currentTarget.blur();

        const newAnswers = [...answers, answerId];
        setAnswers(newAnswers);

        if (currentQuestion < questions.length - 1) {
            setCurrentQuestion(currentQuestion + 1);
        } else {
            onQuizComplete(newAnswers);
        }
    };

    const currentQuestionData = questions[currentQuestion];

    return (
        <Box className={classes.container}>
            {/* Background Image */}
            <Box className={classes.backgroundImage}>
                <img
                    src={breweryImage}
                    alt="Brewery background"
                    className={classes.breweryImage}
                />
            </Box>

            {/* Content Overlay */}
            <Box className={classes.contentOverlay}>
                {/* Logo and Title Section */}
                <Box className={classes.headerSection}>
                    <img
                        src={logoText}
                        alt="Kozel Perfect Match"
                        className={classes.logoImage}
                    />
                </Box>

                {/* Question Section */}
                <Box className={classes.questionSection}>
                    <h2 className={classes.subtitle}>TU CU CINE FACI PERECHEA PERFECTĂ?</h2>
                    {/* Progress indicator */}
                    <Box className={classes.progressContainer}>
                        <Box className={classes.progressText}>
                            {String(currentQuestionData.id).padStart(2, '0')}/05
                        </Box>
                    </Box>

                    {/* Question Box */}
                    <Box className={classes.questionBox}>
                        <h3 className={classes.questionText}>
                            {currentQuestionData.text}
                        </h3>
                    </Box>

                    {/* Answers Section */}
                    <Box className={classes.answersContainer}>
                        {currentQuestionData.answers.map((answer) => (
                            <button
                                key={answer.id}
                                onClick={(e) => handleAnswerClick(answer.id, e)}
                                onTouchEnd={(e) => e.currentTarget.blur()}
                                className={classes.answerButton}
                            >
                                {answer.text}
                            </button>
                        ))}
                    </Box>
                    <img
                        src={promoalcool}
                        alt="Promo Alcool"
                        className={classes.promoalcool}
                    />
                </Box>

                {/* Characters Section */}
                <Box className={classes.charactersSection}>
                    <img
                        src={womanImage}
                        alt="Woman with beer"
                        className={classes.characterLeft}
                    />
                    <img
                        src={goatImage}
                        alt="Kozel goat"
                        className={classes.characterCenter}
                    />
                    <img
                        src={manImage}
                        alt="Man with beer"
                        className={classes.characterRight}
                    />
                </Box>
            </Box>
        </Box>
    );
};

export default Quiz;